export default __webpack_public_path__ + "a8161c62bb573f1a2ecd3c34ad1c190a.jpg";